var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    fillRule: "evenodd",
    d: "M15.847 2a1 1 0 0 1 .708.293l3.652 3.654a1 1 0 0 1 0 1.414L9.866 17.707a1 1 0 0 1-.707.293H5.5a1 1 0 0 1-1-1v-3.64a1 1 0 0 1 .292-.707L15.14 2.293A1 1 0 0 1 15.847 2Zm0 2.415L6.5 13.774V16h2.244l9.342-9.346-2.238-2.24ZM2.5 21a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2h-18a1 1 0 0 1-1-1Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.60379b4c.svg";
export { ForwardRef as ReactComponent };